export default "__VITE_ASSET__DkTOVDy8__"